/*
 * @Author: your name
 * @Date: 2022-02-23 18:27:08
 * @LastEditTime: 2022-04-08 15:18:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ShopTask-goshop\src\i18n\index.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";
import inLocale from "./idn.json";
// import inCom from "@tt/i18n/src/idn";
import thLocale from "./th";
import thCom from "@tt/i18n/src/th";
import trLocale from "./tr";
import trCom from "@tt/i18n/src/tr";
import en from './en.json';
import vi from "./vi.json";
import pt from "./pt.json";
import tl from "./tl.json";
import ms from "./ms.json";
import es from "./es.json";
import ja from "./ja.json";
import verConfig from "@/utils/verConfig"
import store from '../store'
import ceb from "./ceb.json"
import fr from "./fr.json"
import hi from "./hi.json"
import ar from "./ar.json"
import tw from "./tw.json"
import ko from "./ko.json"


Vue.use(VueI18n);

const messages = {
  en: {
    ...en,
  },
  tl: {
    ...tl
  },
  vi: {
    ...vi
  },
  ceb,
  fr,
  hi,
  ar,
  tw,
  ja,
  ko
  // zh: {
  //   ...zhLocale,
  // },
  // idn: {
  //   ...inLocale,
  // },
  // ms: {
  //   ...ms
  // },
  // pt: {
  //   ...pt
  // },
  // es: {
  //   ...es
  // },
  // ja: {
  //   ...ja
  // }
  // th: {
  //   ...thCom,
  //   ...thLocale,
  // },
  // tr: {
  //   ...trCom,
  //   ...trLocale,
  // },
};

export const Lans = [
  // {
  //   name: "แบบไทย",
  //   value: "th"
  // },
  {
    icon: require("./icon/en.png"),
    name: "English",
    value: "en"
  },
  {
    name: "繁体中文",
    value: "tw"
  },
  {
    icon: require("./icon/ja.png"),
    name: "日本語",
    value: "ja"
  },
  {
    name: "Tiếng Việt",
    value: "vi"
  },
  {
    name: "Korean",
    value: "ko"
  },
  {
    icon: require("./icon/tl.png"),
    name: "Filipino",
    value: "tl"
  },

  // {
  //   icon: require("./icon/tl.png"),
  //   name: "Cebuano",
  //   value: "ceb"
  // },
  // {
  //   name: "French",
  //   value: "fr"
  // },
  // {
  //   icon: require("./icon/tl.png"),
  //   name: "Hindi",
  //   value: "hi"
  // },
  // {
  //   name: "Arabic",
  //   value: "ar"
  // }
  // {
  //   icon: require("./icon/idn.png"),
  //   name: "Indonesian",
  //   value: "idn"
  // },
  // {
  //   icon: require("./icon/ms.png"),
  //   name: "Melayu",
  //   value: "ms"
  // },
  // {
  //   icon: require("./icon/pt.png"),
  //   name: "Portuguese",
  //   value: "pt"
  // },
  // {
  //   icon: require("./icon/es.png"),
  //   name: "Español",
  //   value: "es"
  // },

]
export function getLanguage() {
  // 从cookis 里面取语言
  const chooseLanguage = Cookies.get("language");
  const lang = Cookies.get("lang");
  //  if (!chooseLanguage) {
  //   Cookies.set("language",verConfig.lan || "en");
  //   localStorage.setItem('language', verConfig.lan || "en")
  // }
  return lang || chooseLanguage || verConfig.lan || "idn"
}
const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
});

export default i18n;
